import axios from 'axios'
import qs from 'qs'
import merge from 'lodash/merge'
import { apiUrl } from  '@/api/config.js'
import { Message } from 'element-ui'

const http = axios.create({
  baseURL: apiUrl,
  timeout: 60000,
  parseJson: true,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  }
})

/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
  return config
}, error => {
  Message.error({
    message: '加载超时'
  })
  return Promise.reject(error)
})
/**
 * 响应拦截
 */
http.interceptors.response.use(async(response) => {
  const res = response.data;
  if (res.code !== 200) {
    Message({
      message: res.msg,
      type: "warning"
    })
  }
  return response.data;
}, error => {
  const response = error.response
  if (response === undefined) {
    return Promise.reject(error)
  }
})

/**
 * 请求地址处理
 * @param {*} actionName action方法名称
 */
 http.adornUrl = (actionName) => {
  // 非生产环境 && 开启代理, 接口前缀统一使用[/proxyApi/]前缀做代理拦截!
  return apiUrl + actionName
}
/**
 * get请求参数处理
 * @param {*} params 参数对象
 * @param {*} openDefultParams 是否开启默认参数?
 */
 http.adornParams = (params = {}, openDefultParams = true) => {
  var defaults = {
    't': new Date().getTime()
  }
  return openDefultParams ? merge(defaults, params) : params
}
/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} openDefultdata 是否开启默认数据?
 * @param {*} contentType 数据格式
 *  json: 'application/json; charset=utf-8'
 *  form: 'application/x-www-form-urlencoded; charset=utf-8'
 */
 http.adornData = (data = {}, openDefultdata = true, contentType = 'json') => {
  var defaults = {
    't': new Date().getTime()
  }
  data = openDefultdata ? merge(defaults, data) : data
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}
http.adorn1Data = (data = {}, openDefultdata = true, contentType = 'application/x-www-form-urlencoded') => {
  var defaults = {
    't': new Date().getTime()
  }
  data = openDefultdata ? merge(defaults, data) : data
  return contentType === 'json' ? JSON.stringify(data) : qs.stringify(data)
}
export default http
